const ERROR_MESSAGES: { [property: string]: string } = {
  SERIALNUMBER : 'Serial Number is required',
};

const apiParameters: { [property: string]: string } = {
  SERIALNUMBER : 'serialNumber',
};

const MAP_PARAMETERS = function (value: string) {
  return apiParameters[value.toUpperCase()] || '';
};

const MAP_ERROR_MESSAGE = function (value: string) {
  return ERROR_MESSAGES[value.toUpperCase()] || '';
};

export {
  MAP_ERROR_MESSAGE,
  MAP_PARAMETERS,
};
